<template>
  <div>
  <div class="tag">
    <div class="d-flex justify-content-between">
      <div class="tag-boxes">
        <div class="d-flex" style="position: absolute; bottom:0;">
          <div v-for="(item ,index) in tagArray" :key="index" @click="doTag(index)" :class="{'tag-active': recordMode === index}" class="tag-body mx-1">{{item}}</div>
        </div>
      </div>
      <img class="back-icon pointer my-4" @click="previousPage" style="height:20px" src="../../../../assets/image/icon/close_lesson.png" />
    </div>
  </div>
    <div class="recordInfo" style="weight:100%;">
      <h3>
        {{$route.params.mode}} {{$t('learning_record')}}:
      </h3>
      <p class="p-0 m-0">
        {{$t('study_time')}}: {{recordInfo.spendTime}}
      </p>
      <div v-if="$route.params.mode==='App'">
        <p class="p-0 m-0">
          {{$t('coins')}}: {{recordInfo.goldNum}}
        </p>
          <p class="p-0 m-0">
          {{$t('AR_unlocked')}}: {{recordInfo.unlockNum}}
        </p>
        <p class="p-0 m-0">
          {{$t('missions_completed')}}: {{recordInfo.missionFinishedNum}}
        </p>
      </div>
    </div>
    <h5 class="py-5">{{$t('click_below_detailed')}}</h5>
    <div class="container">
      <div class="row">
        <div v-for="(item,index) in countrys" :key="index" class="px-2 countrys-box">
          <div @click="goUnit(item.id)" class="unit-box">
            <img :src="item.pic" style="width:100%"/>
            <h5>
              <span v-if="locale==='tw'">
                {{item.name}}
              </span>
              <br/>
              {{item.englishName}}
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Popup from './Popup'
import api from '../../../../store/api'
export default {

  name: 'ARRecordCountry',

  data () {
    return {
      tagArray: [this.$t('web_record'), this.$t('app_record')],
      countrys: [],
      lessonList: [],
      recordInfo: {},
      countryId: '',
      locale: window.localStorage.getItem('locale')
    }
  },
  components: {
    Popup
  },
  computed: {
    userId () {
      return this.$store.state.auth.user.id
    },
    recordMode () {
      switch (this.$route.params.mode) {
        case 'Web':
          return 0
        case 'App':
          return 1
      }
    }
  },
  watch: {
    recordMode (val) {
      this.getRecordSummary()
    }
  },
  mounted () {
    this.getCountry()
    this.getRecordSummary()
  },
  methods: {
    async getCountry () {
      const { data } = await api.get('/Globetrotting/Country')
      if (data.status === 'OK') {
        this.countrys = data.data
        let pic = ['us', 'br', 'eg', 'fr', 'gb', 'de', 'ru', 'jp', 'in', 'au']
        let englishName = ['The US', 'Brazil', 'Egypt', 'France', 'The UK', 'Germany', 'Russia', 'Japan', 'India', 'Australia']
        this.countrys.map((el, count) => {
          el.pic = require(`../../../../assets/image/cloud/btn_flag_${pic[count]}.png`)
          el.englishName = englishName[count]
        })
      }
    },
    async getRecordSummary () {
      const { data } = await api.get(`/Globetrotting/Record/${this.$route.params.mode}/Summary`, {
        params: {
          userId: this.userId,
          countryId: this.countryId
        }
      })
      this.recordInfo = data.data[0]
    },
    doTag (mode) {
      this.$router.push({name: 'Record.country', params: {mode: mode ? 'App' : 'Web'}})
    },
    goUnit (id) {
      this.$router.push({name: 'Record.lesson', params: { mode: this.$route.params.mode, country: id }})
    },
    previousPage () {
      this.$router.push({name: 'ARIndex'})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/style/color.scss";

  .tag {
    text-align: left;
    border-bottom: #bbbbbb solid 2px;
    .tag-boxes {
      margin-left: 60px;
      position: relative;
    }
  }
  .tag-body {
    white-space:nowrap;
		cursor: pointer;
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px 10px 0 0;
    border-top: 2px #c7c7c7 solid;
    border-right: 2px #c7c7c7 solid;
    border-left: 2px #c7c7c7 solid;
    color: #000000;
		&:hover {
      background-color: #c7c7c7;
    }
	}
  .tag-active {
    border-radius: 10px 10px 0 0;
    background-color: #c7c7c7;
  }
  .back-icon {
    margin-right: 40px;
    margin-left: 40px;
    cursor: pointer;
  }
  .scene-select {
    margin: auto 5px !important;
  }
  .border-box {
    cursor: pointer;
    border-radius:0 0 10px 10px;
    border: 1.5px solid #6666;
    &:hover {
      box-shadow:0px 0px 8px #a1a1a1;
    }
  }
  .recordInfo {
    text-align: left;
    border-bottom: 1px #a1a1a1 solid;
    padding: 50px 10%;
    min-height: 30vh;
    p {
      font-size: 1.5rem;
    }
    h3 {
      font-weight: bold;
    }
  }
  .countrys-box {
    width: 20%;
  }
  .unit-box {
		cursor: pointer;
    background-size: contain;
    background-repeat: no-repeat;
		width: 100%;
		margin: auto;
		margin-bottom: 30px;
		position: relative;
		h5 {
			width: 100%;
			position: absolute;
			bottom: 50px;
    }
    &:hover {
      filter: drop-shadow(0px 0px 8px #a1a1a1)
    }
  }
  @media screen and (max-width: 1200px) {
    .countrys-box {
      width: 50%;
    }
  }
  @media screen and (max-width: 700px) {
    .countrys-box {
      width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// RecordCountry.vue?0c010238